import { useDataProvider } from "react-admin";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const DoctoralRankingSummary = ({ seatId, rankingUrl }) => {
  const dataProvider = useDataProvider();
  const [summary, setSummary] = useState();

  useEffect(() => {
    const fetchSummary = async () => {
      const { data } = await dataProvider.getOne(`${rankingUrl}/summary`, { id: seatId });
      setSummary(data);
    };

    fetchSummary();
  }, [dataProvider, rankingUrl, seatId]);

  if (!summary) {
    return null;
  }

  const cells = [
    { label: "Приети", value: summary.accepted },
    { label: "Неприети", value: summary.notAccepted },
    { label: "Приети в по-високо желание", value: summary.acceptedInHigherPriority },
    { label: "Общо", value: summary.total },
  ];

  return (
    <Box display="flex" justifyContent="space-around" mt={2}>
      {cells.map(cell => (
        <Box key={cell.label} textAlign="center">
          <Typography variant="subtitle1">{cell.label}</Typography>
          <Typography variant="h5">{cell.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default DoctoralRankingSummary;
